import Vue from "vue";
import Router from "vue-router";

import Index from "components/index/index";
import AboutUs from "components/aboutus/aboutus";
import Media from "components/media/media";
import JoinUs from "components/joinus/joinus";
import Tht from "components/tht/tht";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "index",
      component: Index
    },
    {
      path: "/about",
      name: "about",
      component: AboutUs
    },
    {
      path: "/media",
      name: "media",
      component: Media
    },
    {
      path: "/joinus",
      name: "joinus",
      component: JoinUs
    },
    {
      path: "/tht",
      name: "tht",
      component: Tht
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js